<template>
    <!-- component 
    <Modal></Modal>-->
    <template v-if="categorie.par_combinaison">
        <template v-if="datesIndex.length">
            <h1 class="my-8 text-center text-lg md:text-xl lg:text-2xl font-bold">{{ __('titre_stages_carte') }}</h1>
            <template v-for="key in datesIndex">
                <div v-if="Object.keys(combinaisonsParDate[key].pm).length && Object.keys(combinaisonsParDate[key].am).length">
                    <h2 @click="changeDate(key)" class="text-md md:text-lg lg:text-xl hover:bg-opacity-50 hover:bg-gray-50 cursor-pointer my-2 py-2 text-gray-700 border-b">
                        <span>
                            <i v-show="key === showCombinaisons" class="fas fa-minus"></i>
                            <i v-show="key !== showCombinaisons" class="fas fa-plus"></i>
                        </span>
                        &nbsp;
                        <template v-if="combinaisonsParDate[key].pm[0].programme.date_fin">
                            <span v-html="__('programmation_periode', [{key: 'DEBUT_MOIS', value: (new Date(combinaisonsParDate[key].pm[0].programme.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(combinaisonsParDate[key].pm[0].programme.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(combinaisonsParDate[key].pm[0].programme.date_debut)).getFullYear()}, {key: 'FIN_JOUR', value: (new Date(combinaisonsParDate[key].pm[0].programme.date_fin)).getDate()}, {key: 'FIN_MOIS', value: (new Date(combinaisonsParDate[key].pm[0].programme.date_fin)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'FIN_ANNEE', value: (new Date(combinaisonsParDate[key].pm[0].programme.date_fin)).getFullYear()}])"></span>
                        </template>
                        <template v-else>
                            <span v-html="__('programmation_semaine', [{key: 'DEBUT_MOIS', value: (new Date(combinaisonsParDate[key].pm[0].programme.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(combinaisonsParDate[key].pm[0].programme.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(combinaisonsParDate[key].pm[0].programme.date_debut)).getFullYear()}])"></span>
                        </template>
                    </h2>

                    <div class="text-center" v-show="key === showCombinaisons">
                        <div class="flex flex-wrap">
                            <div class="w-full md:w-1/2 p-4 md:border-r-2">
                                <h3 class="text-cavilam-primary font-semibold text-md md:text-lg">{{ __('module_matin') }}</h3>
                                <section class="w-full flex flex-row flex-wrap items-stretch">
                                    <div :id="coursMatin.programme.id" v-for="(coursMatin) in combinaisonsParDate[key].am" class="w-full lg:w-1/2 xl:w-1/3 p-4">
                                        <button @click="choisirModuleMatin(coursMatin)"
                                                style="min-height: 150px;"
                                                :class="{ 'bg-cavilam-primary text-white' : moduleMatin && moduleMatin.programme.id === coursMatin.programme.id, 'bg-white text-black' : !moduleMatin || moduleMatin.programme.id !== coursMatin.programme.id }"
                                                class="hover:bg-cavilam-primary hover:text-white text-center transition-all duration-150 w-full h-full px-4 py-6 transition-all duration-150 rounded-sm shadow-md hover:shadow-lg">
                                            <span class="font-medium">{{ __(coursMatin.produit.slug) }}</span>
                                        </button>
                                    </div>
                                </section>
                            </div>

                            <div class="w-full md:w-1/2 p-4">
                                <h3 class="text-cavilam-primary font-semibold text-lg">{{ __('module_apres_midi') }}</h3>
                                <section class="w-full flex flex-row flex-wrap items-stretch">
                                    <div :id="coursSoir.programme.id" v-for="(coursSoir) in coursSoirVisible" class="w-full lg:w-1/2 xl:w-1/3 p-4">
                                        <button @click="choisirModuleSoir(coursSoir)"
                                                style="min-height: 150px;"
                                                :class="{ 'bg-cavilam-primary text-white' : moduleSoir && moduleSoir.programme.id === coursSoir.programme.id, 'bg-white text-black' : !moduleSoir || moduleSoir.programme.id !== coursSoir.programme.id, 'opacity-75': estInterdit(coursSoir.programme.id) }"
                                                :disabled="estInterdit(coursSoir.programme.id)"
                                                class="hover:bg-cavilam-primary hover:text-white text-center transition-all duration-150 w-full h-full px-4 py-6 transition-all duration-150 rounded-sm shadow-md hover:shadow-lg">
                                            <span class="font-medium">{{ __(coursSoir.produit.slug) }}</span>
                                        </button>
                                    </div>
                                </section>
                            </div>
                        </div>
                        <div class="my-4 text-center">
                            <span class="text-cavilam-secondary font-semibold text-xl" v-html="prixCombinaison"></span>
                        </div>
                        <breeze-button @click="envoyerCombinaison"
                           :class="{ 'opacity-25': !stagesChoisis }"
                           :disabled="!stagesChoisis">
                            {{ __('valider') }}
                        </breeze-button>
                    </div>
                </div>
            </template>
        </template>
        <template v-else>
            <div class="m-auto md:w-2/4 shadow-md bg-white p-8 rounded-md">
                <p class="font-bold text-center">{{ __('pas_de_stage') }}</p>
            </div>
        </template>
    </template>
    <template v-else>
        <template v-if="categorie.produits.length && produits && produits.length">
            <div class="min-h-screen flex justify-center">
                <div class="max-w-2xl w-full px-4">
                    <!-- box -->
                    <template v-for="(produit) in produits">
                        <template v-if="produit.url_redirection">
                            <a :id="produit.id"
                               :href="produit.url_redirection" target="_blank"
                               style="min-height: 150px;"
                               class="w-full max-h-44 flex my-2 bg-white border-2 border-gray-300 shadow-xs hover:shadow-md text-left">
                                <div class="w-full flex py-2 px-4 justify-center flex-col">
                                    <h4 class="text-2xl font-bold overflow-hidden overflow-ellipsis">{{ __(produit.slug) }}</h4>
                                    <p class="text-md text-gray-700 overflow-hidden overflow-ellipsis"><span v-if="produit.description">{{ __(produit.description) }}</span></p>
                                </div>
                            </a>
                        </template>
                        <template v-else>
                            <inertia-link :id="produit.id"
                                  :href="route('inscription.programmer', {'type': type.slug, 'categorie': categorie.slug, 'produit': produit.slug})"
                                  style="min-height: 150px;"
                                  class="w-full max-h-44 flex my-2 bg-white border-2 border-gray-300 shadow-xs hover:shadow-md text-left">
                                <div class="w-full flex py-2 px-4 justify-center flex-col">
                                    <h4 class="text-2xl font-bold overflow-hidden overflow-ellipsis">{{ __(produit.slug) }}</h4>
                                    <p class="text-md text-gray-700 overflow-hidden overflow-ellipsis"><span v-if="produit.description">{{ __(produit.description) }}</span></p>
                                </div>
                            </inertia-link>
                        </template>
                    </template>
                    <!-- box -->
                </div>
            </div>
        </template>
        <template v-else>
            <div class="m-auto md:w-2/4 shadow-md bg-white p-8 rounded-md">
                <p class="font-bold text-center">{{ __('pas_de_cours_disponible') }}</p>
            </div>
        </template>
    </template>
</template>

<script>
import App from '@/Layouts/App'
import BreezeButton from '@/Components/Button'
//import Modal from '@/Components/Modal.vue'

export default {
    name: "Produits",
    layout: App,
    components: {
        BreezeButton,
      //  Modal,
    },
    props: {
        type: String,
        categorie: Object,
        produits: Array,
    },
    data: function () {
        return {
            selectedDate: null,
            moduleMatin: null,
            moduleSoir: null,
        }
    },
    methods: {
        estInterdit(idSoir) {
            for(let i in this.moduleMatin?.programme?.exceptions) {
                let exception = this.moduleMatin?.programme?.exceptions[i];
                if(idSoir === exception.programme_soir)
                    return true;
            }
            return false;
        },
        resetChoixModules() {
            this.moduleMatin = null;
            this.moduleSoir = null;

            // On réaffiche tous les modules
            for (let produit of this.combinaisonsParDate[this.selectedDate || this.datesIndex[0]].pm) {
                produit.produit.hidden = false;
            }
        },
        changeDate(key) {
            if(this.selectedDate !== key) {
                this.resetChoixModules();
                this.selectedDate = key;
            }
        },
        choisirModuleMatin(module) {
            this.resetChoixModules();
            this.moduleMatin = module;

            // Cas particulier pour TV5 Monde
            if (this.moduleMatin?.produit?.slug.includes('tv5monde')) {
                for (let produit of this.combinaisonsParDate[this.selectedDate || this.datesIndex[0]].pm) {
                    if (produit.produit.slug.includes('les-medias')) continue;
                    produit.produit.hidden = true;
                }
            }
        },
        choisirModuleSoir(module) {
            this.moduleSoir = module;
        },
        envoyerCombinaison() {
            if(this.moduleMatin && this.moduleSoir)
                this.$inertia.visit(this.route('stages.ajout', { 'matin': this.moduleMatin.programme.id, 'soir': this.moduleSoir.programme.id }));
        },
        getMontantProduitByDate(produit, date) {
            let anneeDebut = (new Date()).getFullYear();
            let tarifs = produit.tarifs;

            if(!tarifs || tarifs.length < 0)
                return 0;

            if(!date)
                anneeDebut = (new Date()).getFullYear();
            else if(date.date_debut)
                anneeDebut = (new Date(date.date_debut)).getFullYear();

            tarifs.sort((a, b) => (a.annee < b.annee) ? 1 : ((b.annee < a.annee) ? -1 : 0))

            for(let tarif in tarifs)
                if(tarifs[tarif].annee <= anneeDebut)
                    return parseFloat(tarifs[tarif].montant);

            return 0;
        },
        timestampToDate(timestamp) {
            return (new Date(parseInt(timestamp)));
        },
        // #region Google Analytics (Tag Manager)
        TM_get_items() {
            let items = [];

            for (let produit of this.produits) {
                let tarif = produit.tarifs.find(tarif => {
                    return tarif.annee == (new Date()).getFullYear();
                });
                if (!tarif) tarif = produit.tarifs[0];
                if (!tarif) tarif = 0;

                items.push({
                    item_id: produit.id,
                    item_name: this.__(produit.slug),
                    item_category: this.__(this.type.slug),
                    item_list_id: this.categorie.id,
                    item_list_name: this.__(this.categorie.slug),
                    price: tarif.montant,
                    quantity: 1,
                });
            }
            return items;
        },
        TM_item_list() {
            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            dataLayer.push({
                event: "view_item_list",
                ecommerce: {
                    item_list_id: this.categorie.id,
                    item_list_name: this.__(this.categorie.slug),
                    items: this.TM_get_items(),
                }
            });
        }
        // #endregion Google Analytics (Tag Manager)
    },
    computed: {
        stagesChoisis() {
            return this.moduleMatin && this.moduleSoir;
        },
        showCombinaisons() {
            if(!this.datesIndex || typeof this.datesIndex !== 'object')
                return undefined;

            if(!this.selectedDate && this.datesIndex.length)
                return this.datesIndex[0];

            return this.selectedDate;
        },
        combinaisonsParDate() {
            let combinaisons = {};

            for(let row in this.produits)
            {
                let produit = this.produits[row];
                if(produit.programmes.length) {
                    for(let column in produit.programmes) {
                        let programme = produit.programmes[column];
                        let jour = (new Date(programme.date_debut)).setHours(0, 0, 0, 0);
                        if(!combinaisons.hasOwnProperty(jour))
                            combinaisons[jour] = { 'am': [], 'pm': [] };

                        let matin = (new Date(programme.date_debut)).toLocaleString('fr-FR', { hour: 'numeric', hour12: true }).includes('AM');
                        if(matin)
                            combinaisons[jour].am.push({ 'produit': produit, 'programme': programme });
                        else
                            combinaisons[jour].pm.push({ 'produit': produit, 'programme': programme });
                    }
                }
            }

            return combinaisons;
        },
        coursSoirVisible() {
            let data = [];
            for (let produit of this.combinaisonsParDate[this.selectedDate || this.datesIndex[0]].pm) {
                if (produit.produit.hidden) continue;
                data.push(produit);
            }
            return data;
        },
        datesIndex() {
            let keys = Object.keys(this.combinaisonsParDate);
            let collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
            return keys.sort(collator.compare);
        },
        prixCombinaison() {
            let prixTotal = 0;
            let matin = this.moduleMatin;
            let soir = this.moduleSoir;

            if(!this.moduleMatin || !this.moduleSoir)
                return this.__('veuillez_choisir_vos_modules');

            // Si on a un montant pour la date, il prend le dessus...
            if(matin.programme.montant)
                prixTotal += parseFloat(matin.programme.montant);
            else
                prixTotal += this.getMontantProduitByDate(matin.produit, matin.programme.date_debut);

            // Si on a un montant pour la date, il prend le dessus...
            if(soir.programme.montant)
                prixTotal += parseFloat(soir.programme.montant);
            else
                prixTotal += this.getMontantProduitByDate(soir.produit, soir.programme.date_debut);

            return prixTotal + ' €';
        },
    },
    mounted() {
        this.TM_item_list();
    }
}
</script>

<style scoped>
</style>
